// extracted by mini-css-extract-plugin
module.exports = {"section":"e_6V","card":"e_7V","cardBody":"e_8V","title":"e_9V","excerpt":"e_-V","author":"e_aW","avatar":"e_bW","authorText":"e_cW","authorName":"e_dW","authorRole":"e_eW"};